"use strict";

angular.module('app.cessao').factory('registroCPRFactory', ['$http', '$q', 'errorService', function ($http, $q, errorService) {

    var _apiName = 'RegistroCPR';

    var _list = function (search, options, dataInicio, dataTermino, parceiro, situacao) {
        var dto = options.data;
        dto.search = search;
        dto.parms = [];
        dto.parms.push({ "name": "DataInicio", "value": dataInicio });
        dto.parms.push({ "name": "DataTermino", "value": dataTermino });
        dto.parms.push({ "name": "Parceiro", "value": parceiro });
        dto.parms.push({ "name": "Situacao", "value": situacao })

        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/List', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _reprocessar = function (dataItem) {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/Reprocessar', dataItem)
    }

    var _listComPropostas = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListComPropostas');
    };

    var factory = {};

    factory.list = _list;
    factory.reprocessar = _reprocessar;
    factory.listComPropostas = _listComPropostas;

    return factory;
}]);
